import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "custom-file__pic" }
const _hoisted_2 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")!

  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    (_ctx.documentIcon)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _ctx.documentIcon,
          alt: _ctx.documentType ? _ctx.documentType + ' document' : 'File',
          class: "custom-file__icon"
        }, null, 8, _hoisted_2))
      : (_openBlock(), _createBlock(_component_icon, {
          key: 1,
          data: _ctx.iconData,
          fill: true,
          width: "var(--icon-24)",
          height: "var(--icon-24)",
          class: "custom-file__icon",
          color: "var(--monochrome05to04)"
        }, null, 8, ["data"]))
  ]))
}